import React, { useRef } from "react";
import Carousel from "../../../shared/components/Carousel";
import { BonusCard } from "../../../shared/components/cards";
import SkeletonBonusCard from "../../../shared/components/skeletons/SkeletonBonusCard";
import AnonymousHero from "../../../shared/components/casino/AnonymousHero";
import StickySignupCTA from "../../../shared/components/casino/StickySignupCTA";

const CARD_WRAPPER = "flex-shrink-0 w-[85%] sm:w-[70%] md:w-[45%] lg:w-[32%]";

/**
 * Top-of-lobby hero slot.
 *
 * Anonymous visitors get the AnonymousHero (first-impression value prop) plus a
 * StickySignupCTA that appears once the hero scrolls out of view. Logged-in
 * players get the rotating promo carousel instead. The two are mutually
 * exclusive - the same slot, audience-gated.
 *
 * Module-scope component (was inline in GameLobby's render body).
 */
const LobbyHero = ({
  isLoggedIn,
  promoList,
  promoCards,
  promosLoading,
  navigate,
}) => {
  const heroRef = useRef(null);

  if (!isLoggedIn) {
    return (
      <>
        <div ref={heroRef}>
          <AnonymousHero />
        </div>
        <StickySignupCTA observeRef={heroRef} />
      </>
    );
  }

  return (
    <div className="mb-12">
      {promosLoading ? (
        <Carousel gap="gap-6" autoPlay autoPlayInterval={5000} equalHeight>
          {promoList.slice(0, 5).map((p, idx) => (
            <div key={`lobby-top-skel-${idx}`} className={CARD_WRAPPER}>
              {p.id === "huge_collection" ? (
                <BonusCard
                  variant={p.variant}
                  subtitle={p.subtitle ?? p.title}
                  title={p.title}
                  highlight={p.highlight}
                  description={p.description}
                  onButtonClick={() => navigate(p.link)}
                  image={p.image}
                />
              ) : (
                <SkeletonBonusCard />
              )}
            </div>
          ))}
        </Carousel>
      ) : (
        <Carousel gap="gap-6" autoPlay autoPlayInterval={5000} equalHeight>
          {promoCards.map((c, idx) => (
            <div key={c.key || idx} className={CARD_WRAPPER}>
              <BonusCard
                variant={c.variant}
                subtitle={c.subtitle}
                title={c.title}
                highlight={c.highlight}
                description={c.description}
                onButtonClick={c.onButtonClick}
                image={c.image}
              />
            </div>
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default LobbyHero;
